document.addEventListener("DOMContentLoaded", () => {

  const checkbox =
    document.querySelector(".gift-box-check");

  const message =
    document.querySelector(".gift-message");

  const messageBox =
    document.querySelector(".gift-message-box");

  const previewText =
    document.querySelector(".gift-preview-text");

  if (!checkbox) {
    console.error("Gift checkbox not found");
    return;
  }


  // ==========================================
  // GIFT MESSAGE SHOW / HIDE
  // ==========================================

  if (messageBox) {

    const updateGiftMessageBox = () => {

      messageBox.style.display =
        checkbox.checked
          ? "block"
          : "none";

    };

    checkbox.addEventListener(
      "change",
      updateGiftMessageBox
    );

    updateGiftMessageBox();
  }


  // ==========================================
  // LIVE MESSAGE PREVIEW
  // ==========================================

  if (message && previewText) {

    const MAX_LINES = 4;
    const MAX_CHARS_PER_LINE = 15;


    message.addEventListener(
      "beforeinput",
      function (e) {

        if (
          !e.data ||
          e.inputType !== "insertText"
        ) {
          return;
        }

        const start =
          this.selectionStart;

        const end =
          this.selectionEnd;

        const value =
          this.value;

        const beforeCursor =
          value.substring(0, start);

        const currentLine =
          beforeCursor
            .split("\n")
            .pop();

        const totalLines =
          value.split("\n").length;


        if (
          currentLine.length >=
          MAX_CHARS_PER_LINE
        ) {

          if (
            totalLines >= MAX_LINES
          ) {
            e.preventDefault();
            return;
          }

          e.preventDefault();

          const newValue =
            value.substring(0, start) +
            "\n" +
            e.data +
            value.substring(end);

          this.value = newValue;

          const pos =
            start + 2;

          this.setSelectionRange(
            pos,
            pos
          );

          this.dispatchEvent(
            new Event("input", {
              bubbles: true
            })
          );
        }

      }
    );


    message.addEventListener(
      "input",
      () => {

        const lines =
          message.value
            .split("\n")
            .slice(0, MAX_LINES);

        previewText.innerHTML =
          lines
            .map(
              line =>
                `<p>${line || "&nbsp;"}</p>`
            )
            .join("");

      }
    );

  }


  // ==========================================
  // GIFT VARIANT
  // ==========================================

  const giftVariantId =
    checkbox.dataset.variantId;

  console.log(
    "Gift Variant ID:",
    giftVariantId
  );


  // ==========================================
  // PRODUCT FORM
  // ==========================================

  // Track in-flight submissions per form so a double-click (or a
  // second submit event of any kind) can't fire a second cart/add call.
  const submittingForms = new WeakSet();

  // IMPORTANT: this listener is attached on `document`, in the
  // CAPTURING phase (the `true` as the 3rd argument). That is what
  // makes it actually work.
  //
  // Why: if the theme itself (e.g. a Dawn-style <product-form>
  // custom element) already attaches its own submit listener
  // directly ON the form element, that listener may have been
  // registered before this script ran. When two listeners sit on
  // the SAME element, `capture: true` does NOT reorder them —
  // they still fire in registration order. So attaching our
  // listener on the form itself, even with capture:true, could
  // still fire AFTER the theme's own listener already added the
  // product to the cart once — causing the duplicate add.
  //
  // By listening on `document` with capture:true instead, our
  // handler runs during the capturing phase, which always reaches
  // `document` before the event reaches the form element itself.
  // That guarantees we intercept and stop the event (via
  // stopImmediatePropagation) before ANY listener on the form
  // (ours or the theme's) can run.
  document.addEventListener(
    "submit",
    async (e) => {

      const form = e.target;

      if (
        !form.matches ||
        !form.matches('form[action*="/cart/add"]')
      ) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      if (submittingForms.has(form)) {
        console.warn(
          "Submit already in progress, ignoring duplicate submit"
        );
        return;
      }

      submittingForms.add(form);

      try {

        const formData =
          new FormData(form);

        const variantId =
          formData.get("id");

        if (!variantId) {
          console.error(
            "Main product variant ID missing"
          );
          return;
        }

        const cartRoot =
          window.Shopify?.routes?.root ||
          "/";

        const addToCartUrl =
          cartRoot + "cart/add.js";


        // ==================================
        // ADD MAIN PRODUCT
        // ==================================

        const mainResponse =
          await fetch(
            addToCartUrl,
            {
              method: "POST",
              body: formData,
              credentials: "same-origin",
              headers: {
                Accept:
                  "application/json"
              }
            }
          );

        const mainData =
          await mainResponse.json();

        console.log(
          "Main product:",
          mainData
        );

        if (
          !mainResponse.ok ||
          mainData.status
        ) {

          console.error(
            "Main product failed:",
            mainData
          );

          return;
        }


        // ==================================
        // ADD GIFT BOX
        // ==================================

        if (
          checkbox.checked &&
          giftVariantId
        ) {

          const giftResponse =
            await fetch(
              addToCartUrl,
              {
                method: "POST",
                credentials: "same-origin",
                headers: {
                  "Content-Type":
                    "application/json",
                  Accept:
                    "application/json"
                },
                body:
                  JSON.stringify({
                    items: [
                      {
                        id:
                          Number(
                            giftVariantId
                          ),

                        quantity: 1,

                        properties: {
                          "Gift Message":
                            message
                              ? message.value
                              : ""
                        }
                      }
                    ]
                  })
              }
            );

          const giftData =
            await giftResponse.json();

          console.log(
            "Gift box:",
            giftData
          );

          if (
            !giftResponse.ok ||
            giftData.status
          ) {

            console.error(
              "Gift box failed:",
              giftData
            );

            return;
          }
        }


        // ==================================
        // VERIFY CART
        // ==================================

        const cartResponse =
          await fetch(
            cartRoot + "cart.js",
            {
              credentials:
                "same-origin",
              cache:
                "no-store"
            }
          );

        const cart =
          await cartResponse.json();

        console.log(
          "Final cart:",
          cart
        );


        // ==================================
        // REDIRECT
        // ==================================

        if (
          cart.item_count > 0
        ) {

          window.location.assign(
            cartRoot + "cart"
          );

        } else {

          console.error(
            "Cart is empty"
          );

        }

      } catch (error) {

        console.error(
          "Cart Error:",
          error
        );

      } finally {

        submittingForms.delete(form);

      }

    },

    true
  );

});
